"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var native_1 = __importDefault(require("styled-components/native"));
var ATLAtomLine_1 = require("../atoms/ATLAtomLine");
exports.BackdropOverlay = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n"], ["\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n"])));
exports.IosKeyboardWrapper = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 35%;\n  background-color: white;\n"], ["\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 35%;\n  background-color: white;\n"])));
exports.IosKeyboardButtonWrapper = native_1.default(react_native_1.TouchableOpacity)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: white;\n  opacity: 0.95;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding: ", "px ", "px;\n"], ["\n  background-color: white;\n  opacity: 0.95;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding: ", "px ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.SpacingAtomic;
}, function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.SpacingMarginal;
});
exports.IosKeyboardButtonText = native_1.default(react_native_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n color: ", ";\n font-size: 20px;\n font-weight: bold;\n"], ["\n color: ", ";\n font-size: 20px;\n font-weight: bold;\n"])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.ColorBrand1Default;
});
exports.IOSKeyboardDate = function (_a) {
    var children = _a.children, modalVisible = _a.modalVisible, handleClose = _a.handleClose;
    var animation = new react_native_1.Animated.Value(0);
    var keyboardGray = '#D2D5DE';
    var handleOpen = function () {
        react_native_1.Animated.timing(animation, {
            toValue: 1,
            duration: 400,
        }).start();
    };
    var renderModal = function () { return (react_1.default.createElement(react_native_1.Modal, { transparent: true, visible: modalVisible, animationType: 'fade', onShow: handleOpen, onRequestClose: handleClose },
        react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: handleClose },
            react_1.default.createElement(exports.BackdropOverlay, null,
                react_1.default.createElement(react_native_1.Animated.View, { style: {
                        flex: 1,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        translateY: animation.interpolate({
                            inputRange: [0, 1],
                            outputRange: [react_native_1.Dimensions.get('screen').height, 0]
                        })
                    } },
                    react_1.default.createElement(exports.IosKeyboardWrapper, null,
                        react_1.default.createElement(ATLAtomLine_1.ATLAtomLine, { color: keyboardGray, thickness: 2 }),
                        react_1.default.createElement(exports.IosKeyboardButtonWrapper, { onPress: handleClose },
                            react_1.default.createElement(exports.IosKeyboardButtonText, null, "Ok")),
                        react_1.default.createElement(ATLAtomLine_1.ATLAtomLine, { color: keyboardGray, thickness: 2 }),
                        react_1.default.createElement(react_native_1.View, { style: { backgroundColor: keyboardGray } }, children))))))); };
    return (react_1.default.createElement(react_native_1.View, null, modalVisible && renderModal()));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
